import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DeleteMemberWorkgroupComponent } from '../../delete-member-workgroup/delete-member-workgroup.component';

@Component({
  selector: 'app-memberListItem',
  templateUrl: './memberlistitem.component.html'
})
export class MemberListItemComponent implements OnInit {
  @Input('workgroupMember') workgroupMember: any;
  @Input('usingClearancelevel') usingClearancelevel!: boolean;
  @Output('triggerAction') triggerAction = new EventEmitter();
  clearancelevels: number[] = [1,2,3,4,5]

  constructor(private modalService: NgbModal) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  deleteMember() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard : false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(DeleteMemberWorkgroupComponent, ngbModalOptions);
    modalRef.componentInstance.userGuid = this.workgroupMember.user.id;
    modalRef.closed.subscribe({
      next: (value: any) => {
        if(value === false) return;
        if(value != null && value != "") {
          this.triggerAction.emit({action: 'removeMemberWorkgroup', id: value});
        }
      }
    });
  }

  changeCurrentClearancelevel(clearanceLevel: number){
    this.workgroupMember.clearanceLevel = clearanceLevel;
  }

}
